import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerCertificateOfStudies: [
    'procedureId',
    'period',
    'program',
    'weightedAverage',
    'hasDebts'
  ],
  // Reducer
  registerCertificateOfStudiesClear: null,
  registerCertificateOfStudiesRequest: null,
  registerCertificateOfStudiesSuccess: null,
  registerCertificateOfStudiesFailure: ['error']
});

export { Creators, Types };
